import React, { useState } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { tennisAudio } from '../../core/audio';
import { umpireVoice } from '../../core/voice';

export const AudioControls: React.FC = () => {
  const [isMuted, setIsMuted] = useState(false);

  const toggleMute = () => {
    const next = !isMuted;
    setIsMuted(next);
    tennisAudio.isMuted = next;
    umpireVoice.isMuted = next;
    if (!next) {
      tennisAudio.playHit('topspin');
    }
  };

  return (
    <button
      onClick={toggleMute}
      className={`p-1.5 rounded-xl border transition-all ${
        isMuted
          ? 'bg-slate-900 border-slate-800 text-slate-500 hover:text-slate-400'
          : 'bg-slate-900/90 border-slate-800 text-lime-400 hover:border-lime-500/40 hover:bg-slate-850'
      }`}
      title={isMuted ? '取消静音 (开启网球击球原声)' : '静音球场原声'}
    >
      {isMuted ? <VolumeX className="w-4 h-4" /> : <Volume2 className="w-4 h-4" />}
    </button>
  );
};
